const hasNoIssues = (issues) => {
  const issueKeys = Object.keys(issues);
  return issueKeys.every((key) => !issues[key].length);
};

const CRITICAL_GROUP = 'critical';
const WARNING_GROUP = 'warning';

const separateUniqueIssues = (issues) => {
  const trackedIssues = [];

  const criticalIssues = getIssuesFor(CRITICAL_GROUP, issues, trackedIssues);
  updateTrackedIssues(trackedIssues, criticalIssues);

  let otherIssues = {};
  for (const key in issues) {
    if (key === CRITICAL_GROUP || key === WARNING_GROUP) {
      continue;
    }

    const filteredIssues = getIssuesFor(key, issues, trackedIssues);
    if (!filteredIssues.length) {
      continue;
    }

    otherIssues[key] = filteredIssues;
    updateTrackedIssues(trackedIssues, filteredIssues);
  }

  const warningIssues = getIssuesFor(WARNING_GROUP, issues, trackedIssues);
  updateTrackedIssues(trackedIssues, warningIssues);

  return {
    criticalIssues,
    warningIssues,
    otherIssues,
  };
};

const getTotalIssues = ({ criticalIssues, warningIssues, otherIssues }) => {
  let total = 0;
  total += criticalIssues.length;
  total += warningIssues.length;
  Object.keys(otherIssues).forEach((key) => (total += otherIssues[key].length));

  return total;
};

const doAllIssuesHaveSameHowToFixLink = (issues) => {
  return issues.length && !issues.some((issue) => issue.howToFixLink !== issues[0].howToFixLink);
};

const filterIssuesWithSameMessageAndLink = (issues) => {
  let filteredIssues = {};
  for (const issueGroup of Object.keys(issues)) {
    filteredIssues[issueGroup] = _filterGroupIssuesWithSameMessageAndLink(issues[issueGroup]);
  }

  return filteredIssues;
};

const _filterGroupIssuesWithSameMessageAndLink = (listOfIssues) => {
  const filtered = listOfIssues.reduce((filteredIssues, issue) => {
    if (
      !filteredIssues.some(
        (item) => item.message === issue.message && item.whereToFixLink === issue.whereToFixLink
      )
    ) {
      filteredIssues.push(issue);
      return filteredIssues;
    }

    return filteredIssues;
  }, []);

  return filtered;
};

function getIssuesFor(key, issues, trackedIssues) {
  return (issues[key] || []).filter((issue) => notTracked(issue, trackedIssues));
}

function notTracked(issue, trackedIssues) {
  return !trackedIssues.includes(JSON.stringify(issue));
}

function updateTrackedIssues(alreadySeparatedIssues, issues) {
  issues.forEach((issue) => {
    alreadySeparatedIssues.push(JSON.stringify(issue));
  });
}

function humanizeIssueKey(issuePropertyName) {
  return issuePropertyName.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
}

module.exports = {
  doAllIssuesHaveSameHowToFixLink,
  hasNoIssues,
  separateUniqueIssues,
  getTotalIssues,
  filterIssuesWithSameMessageAndLink,
  humanizeIssueKey,
};
